import { cn } from "@/lib/utils"

type LogoVariant = "wordmark" | "icon"

const LOGO_SOURCES: Record<LogoVariant, string> = {
  wordmark: "/Branding/logotext.png",
  icon: "/Branding/logosymbol.png",
}

/**
 * Brand logo.
 *
 * - `wordmark` (icon + "Creatix"): use where the brand is introduced and there is
 *   horizontal room -- marketing nav on desktop, footer, auth card, desktop app bar.
 * - `icon` (symbol only): use in tight, square, or system contexts -- mobile bars,
 *   favicon/PWA, wallet connect, avatars.
 */
export function Logo({
  variant = "wordmark",
  className,
}: {
  variant?: LogoVariant
  className?: string
}) {
  return (
    <img
      src={LOGO_SOURCES[variant]}
      alt="Creatix"
      className={cn(
        "object-contain shrink-0",
        variant === "icon" ? "h-8 w-8" : "h-8 w-auto",
        className,
      )}
    />
  )
}
